.container {
  scroll-snap-align: center;
  width: 100%;
  min-width: 100%;

  &[data-zoom='3'],
  &[data-zoom='4'],
  &[data-zoom='5'],
  &[data-zoom='6'] {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    border-radius: var(--border-radius-medium);
    border: 2px dashed var(--color-grey-3);
    padding: 2.4rem;
    position: relative;
  }

  &:hover {
    cursor: pointer;
  }
}

.title {
  font-family: Inter, sans-serif;
  font-weight: 300;
  color: var(--white-default);
  font-size: 18px;
  letter-spacing: -0.5px;
  line-height: 18px;
  text-align: center;

  b {
    font-weight: 300;
    color: var(--color-primary);
  }
}

.folder-container-accepted-files-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 0.4rem;
}

.folder-container-accepted-files {
  height: 1.4rem;
  margin-left: 0.6rem;
  color: var(--color-text-grey-light);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.4rem;
  text-align: center;
}

.folder-container-upload {
  display: flex;
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  align-content: center;

  svg {
    margin: auto;
  }
}

.folder-container-upload-drag-and-drop {
  height: 1.4rem;
  font-family: Inter, sans-serif;
  font-weight: bold;
  letter-spacing: -0.25px;
  line-height: 2rem;
  text-align: center;
  margin-top: 1.2rem;
}

.folder-container-upload-browse {
  height: 1.4rem;
  color: var(--color-primary);
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  font-weight: bold;
  letter-spacing: -0.25px;
  line-height: 2rem;
  text-align: center;
  margin-top: 1.2rem;
}
